"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = DashSmall;

var _DashSmall = require("@adobe/react-spectrum-ui/dist/DashSmall.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function DashSmall(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_DashSmall.DashSmall, null));
}